<template>
  <div :style="'font-size:'+fontSize+'px;line-height:'+(fontSize*2)+'px;padding-left:20px;'">
    <template v-if="item.setMenuOneItemList&&item.setMenuOneItemList.length">
      <div v-for="(x1,i1) in item.setMenuOneItemList" :key="i1">
        <div v-for="(x2,i2) in x1.itemList" :key="i2">
          <div class="df-c-fs w100p f-gray" v-if="x1.fixed||x2.id!==0">
            <div style="max-width:80%;" class="df-c-fs">
              <div class="sls fsk0">{{x2['name'+_lang]}}&nbsp;</div>
              <div class="df-c-fs sls" v-if="x2.itemDetailList&&x2.itemDetailList.length">
                (&nbsp;<span class="sls">
                  <span v-for="(x3,i3) in x2.itemDetailList" :key="i3">
                    <span v-for="(x4,i4) in x3.nameAndPriceList" :key="i4" v-if="x4.select">{{x4['name'+_lang]}}&nbsp;</span>
                  </span>
                </span>)
              </div>
            </div>
            <div style="max-width:20%;" class="sls">&nbsp;*{{x2.countInOrder}}</div>
          </div>
        </div>
      </div>
    </template>
    <!-- 菜品细节 -->
    <template v-else-if="item.itemDetailList&&item.itemDetailList.length">
      <div class="sls f-gray">
        <span v-for="(x1,i1) in item.itemDetailList" :key="i1">
          <span v-for="(x2,i2) in x1.nameAndPriceList" :key="i2">{{x2['name'+_lang]+' '}}</span>
        </span>
      </div>
    </template>
    <!-- 备注 -->
    <div class="sls f-gray">
      <span>
        <span>{{item|toremark(false)}}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartItemDetail',
  props: {
    item: {
      type: Object,
      default: {}
    },
    fontSize: {
      type: Number,
      default: 12,
    },
  },
}
</script>

<style lang="scss" scoped>
</style>